<template>
  <div class="footer">
    <!--
      <img src = "/static/img/logo_medialab.jpg" />
    -->
    <div class = "has-text-centered">
      <strong>Programalaplaza 2021</strong> <br/>

      <p>Proyecto ideado y desarollado por
        <a href = "http://sergio.eclectico.net">Sergio Galán</a>
        y
        <a href = "http://www.victordiazbarrales.com">Victor Díaz</a>
        para
        <a href="http://medialab-prado.es">Medialab-prado</a>
      </p>
      Contacto e información en <a href="mailto:programalaplaza@gmail.com">programalaplaza@gmail.com</a>.
    </div>

  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.footer {
  opacity: 1;
  margin-top: 120px;
  margin-bottom: 0px;
  font-family: 'Share Tech';

  img {
    max-height: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/UI/Footer.vue